import React, { Component } from "react";
import Grid from "@mui/material/Grid";
import { Breadcrumbs, Typography } from "@mui/material";
import Link from "@mui/material/Link";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import CtBtn from "../Components/CustomTool/CtBtn";
import CtMultiLineText from "../Components/CustomTool/CtMultiLineText";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { withRouter } from "../HOC/withRouter";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";

class AMCGetLocation extends Component {
  state = {
    formData: {
      txtLocationLink: "",
    },
  };

  componentDidMount() {
    document.title = "AMC Get Location";
    localStorage.setItem("Heading", "AMC Get Location");
    this.props.verifyUserID(this.getInfo, this.props.setUserPrivileges);
  }

  getInfo = () => {};

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  importLocation = () => {
    if (!this.state.formData.txtLocationLink) {
      this.props.toastErrorMsg("Enter Location Link", "txtLocationLink");
      return;
    }
    this.props.toastMsg("success", "Location Imported Successfully");
  };

  render() {
    return (
      <form>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="#/Dashboard">
            Dashboard
          </Link>
          <Link underline="hover" color="inherit" href="#/AMCDashboard">
            AMC Dashboard
          </Link>
          <Typography sx={{ color: "text.primary" }}>Get Location</Typography>
        </Breadcrumbs>

        <Grid container spacing={2} marginTop={2}>
          <Grid item xs={12}>
            <CtMultiLineText
              id="txtLocationLink"
              label="Add Location Link*"
              value={this.state.formData.txtLocationLink}
              handleOnChange={this.handleOnChange}
              width={520}
              maxLength={1000}
            />
          </Grid>
          <Grid item>
            <CtBtn
              label="Import Location"
              className="secondary-button"
              onClick={this.importLocation}
            />
          </Grid>
        </Grid>
      </form>
    );
  }
}

function WithNavigate(props) {
  const navigate = useNavigate();
  return <AMCGetLocation {...props} navigate={navigate} />;
}

export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps,
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
